/* tslint:disable */
/* eslint-disable */
/* @relayHash a2d781b3b45bee27cdba675b58f4109d */

import { ConcreteRequest } from "relay-runtime";
export type FirmInteriorPortfolioMutationInput = {
    firmId: string;
    portfolioId: string;
    clientMutationId?: string | null;
};
export type firmPortfolioMutationVariables = {
    input: FirmInteriorPortfolioMutationInput;
};
export type firmPortfolioMutationResponse = {
    readonly firmInteriorPortfolioMutation: {
        readonly tradeFirm: {
            readonly serviceId: string | null;
        } | null;
    } | null;
};
export type firmPortfolioMutation = {
    readonly response: firmPortfolioMutationResponse;
    readonly variables: firmPortfolioMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmInteriorPortfolioMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "firmPortfolioMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmInteriorPortfolioMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmInteriorPortfolioMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "firmPortfolioMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmInteriorPortfolioMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmInteriorPortfolioMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "firmPortfolioMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/firmPortfolioMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'a71adfc880f10c041efe19003110a145';
export default node;
